/**
 * The TextSvgPreview component
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Alert, Spinner } from "reactstrap";
import Tspan from "./Tspan";
import { isServer } from "../../../redux/store";
import canvasBackground from "../../../assets/images/canvas-background.png";

const stageScalingFactors = [
  { match: "(min-width: 1200px)", scale: 1.65 },
  { match: "(max-width: 1200px)", scale: 1.4 },
  { match: "(max-width: 992px)", scale: 1.26 },
  { match: "(max-width: 768px)", scale: 1.05 },
  { match: "(max-width: 576px)", scale: 0.79 },
  { match: "(max-width: 370px)", scale: 0.59 },
];

/**
 * Stateless react component to render the TextSvgPreview page
 * @param {Object} props the props passed to the page.
 */
class TextSvgPreview extends Component {
  componentDidMount() {
    this.scaleContentToPreview();
  }

  componentDidUpdate() {
    this.scaleContentToPreview();
  }

  // checkLineHeightConstraints() {
  //   const { size, lines } = this.props;

  //   let foundTooSmallLine = false;
  //   lines.forEach((line) => {
  //     const fontMinHeight = line.font.min_font_size;
  //     if ((line.text !== '') && ((size.matrix === 'width' && line.computedLineHeight / size.productionScaleFactor * size.scaleFactor <= fontMinHeight) || (size.matrix === 'height' && line.computedLineHeight * size.width / size.previewWidth * size.scaleFactor <= fontMinHeight))) {
  //       foundTooSmallLine = true;
  //     }
  //   });
  //   return foundTooSmallLine;
  // }

  scaleContentToPreview() {
    const textSvg = this.refs.text;
    const {
      updatePreviewSize,
      updateScaleFactor,
      updateRatio,
      size,
      // lines,
      changeDimensionsOnSvgRerender,
    } = this.props;
    if (textSvg && textSvg.getBBox) {
      const bbox = textSvg.getBBox();

      // do nothing if nothing to see
      if (bbox.width === 0) {
        return;
      }
      const scaleFactor = (1 / bbox.width) * size.previewWidth;
      // let didUpdateScaleFactor = false;
      // let didUpdateRatioAndSize = false;

      // let computedPositionY = 0;
      // lines.map((ll) => {
      //   computedPositionY += ll.computedLineHeight * ll.lineHeight;
      // });

      // console.log(
      //   "Old Scale",
      //   size.scaleFactor,
      //   scaleFactor,
      //   bbox.width,
      //   size.previewWidth,
      //   "computedPositionY:",
      //   computedPositionY
      // );
      if (bbox.width !== size.previewWidth) {
        if (scaleFactor !== 1 && size.scaleFactor !== scaleFactor) {
          // didUpdateScaleFactor = true;
          updateScaleFactor(scaleFactor);
        }
      }

      const scaledHeight = bbox.height * size.scaleFactor;
      if (scaledHeight !== size.previewHeight) {
        // didUpdateRatioAndSize = true;
        let width = size.width;
        let height = size.height;
        updatePreviewSize({ width: 460, height: scaledHeight }); // TODO find better place for fixed width for preview (stage size)
        updateRatio({ width: bbox.width, height: bbox.height });
        const ratio = bbox.height / bbox.width;

        if (size.matrix === "width") {
          height = width * ratio;
        } else {
          width = height / ratio;
        }
        changeDimensionsOnSvgRerender(width, height);
      }
    }

    // console.log(
    //   "*PLAIN*",
    //   "width:",
    //   bbox.width * size.previewWidth,
    //   bbox.width,
    //   size.previewWidth,
    //   "height:",
    //   scaledHeight,
    //   bbox.height,
    //   size.previewHeight,
    //   "scaleFactor:",
    //   scaleFactor,
    //   "ratio:",
    //   bbox.width / bbox.height,
    //   "didUpdateRatioAndSize:",
    //   didUpdateRatioAndSize,
    //   "didUpdateScaleFactor:",
    //   didUpdateScaleFactor
    // );
  }

  updateStageHeight() {
    const { size } = this.props;
    let height = size.previewHeight;
    if (!isServer) {
      stageScalingFactors.forEach((factor) => {
        if (window.matchMedia(factor.match).matches) {
          height = size.previewHeight * factor.scale;
        }
      });
    }

    return height;
  }

  render() {
    const {
      checkLineHeightConstraints,
      lines,
      size,
      mirrorSvg,
      changeComputedLineSize,
      resetFontStyle,
      loadingFont,
      missingChars,
    } = this.props;
    const { context } = this;
    const transform = mirrorSvg
      ? "translate(" +
        size.previewWidth +
        ",0) scale(" +
        -size.scaleFactor +
        "," +
        size.scaleFactor +
        ")"
      : "translate(0,0) scale(" +
        size.scaleFactor +
        "," +
        size.scaleFactor +
        ")";
    const showSmallLineAlert = checkLineHeightConstraints();
    const height = this.updateStageHeight();
    return (
      <div>
        {!loadingFont && showSmallLineAlert && (
          <Alert color="danger">
            <p>
              {context.t(
                "A Line is too small and, thus not producible, please increase the sizes of the whole foil or the texts font sizes."
              )}
            </p>
          </Alert>
        )}
        {Object.keys(missingChars).length > 0 && (
          <Alert color="danger">
            {this.context.t(
              `Your selected fonts can not represent all characters in your text:`
            )}
            {Object.keys(missingChars).map((line) => {
              return (
                <p
                  key={"missing_chars_for_line" + line}
                  className="svg-preview-missingchars-font"
                >
                  {" "}
                  {missingChars[line].font.title}:{" "}
                  <span> {missingChars[line].missing.toString()} </span>
                </p>
              );
            })}
          </Alert>
        )}

        <div
          id="stage"
          style={{
            height: height,
            backgroundImage: `url(${canvasBackground})`,
          }}
          ref="stage"
          className="svg-preview"
        >
          {loadingFont && (
            <div className="d-flex align-items-center justify-content-center flex-column w-100 h-100">
              <Spinner color="primary" />
              <div className="mt-2 lead">{context.t("Font is loading")}</div>
            </div>
          )}
          <svg
            id="text-svg"
            style={
              loadingFont ? { visibility: "hidden" } : { display: "block" }
            }
            height={size.previewHeight}
            version="1.1"
            width={size.previewWidth}
            xmlns="http://www.w3.org/2000/svg"
          >
            <g ref="text" transform={transform}>
              {lines.map((line, idx) => {
                return (
                  <Tspan
                    key={`line_${idx}_key`}
                    line={line}
                    lines={lines}
                    lineNum={idx + 1}
                    changeComputedLineSize={changeComputedLineSize}
                    resetFontStyle={resetFontStyle}
                    asPath
                  />
                );
              })}
            </g>
          </svg>

          {/* <button onClick={this.scaleContentToPreview.bind(this)}>SCALE</button> */}
        </div>
      </div>
    );
  }
}

TextSvgPreview.contextTypes = {
  t: PropTypes.func,
};
export default TextSvgPreview;
